export default __webpack_public_path__ + "3746a6a5eacccb1b81beb5677d8b4e60.png";